import React from "react";
import LegalStrip from "./LegalStrip";

const ContactCTA = ({ agent, property }) => {
  const subject = encodeURIComponent(`Active Buyer Report - ${property.addressLine1}`);
  const mailto = `mailto:${agent.email}?subject=${subject}`;
  const tel = `tel:${agent.phoneTel}`;
  return (
    <section id="cta" className="abr-section abr-cta" aria-labelledby="abr-cta-title">
      <div className="abr-cta-grid">
        <div>
          <div className="abr-cta-eyebrow">What happens next</div>
          <h2 className="abr-cta-title" id="abr-cta-title">
            Have questions about any number in this report?
          </h2>
          <p className="abr-cta-body">
            Reach out to {agent.firstName} for a walkthrough of the match pool, a live look at the matching dashboard,
            or to talk through how priorities and gaps could shape your pricing conversation.
          </p>
          <div className="abr-cta-btn-row">
            <a href={tel} className="abr-btn is-primary">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.86 19.86 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.86 19.86 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
              </svg>
              Call {agent.firstName}
            </a>
            <a href={mailto} className="abr-btn is-secondary">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                <polyline points="22,6 12,13 2,6" />
              </svg>
              Email
            </a>
          </div>
        </div>
        <div className="abr-cta-card">
          <img src={agent.photoUrl} alt={agent.fullName} />
          <div>
            <div className="abr-cta-name">{agent.fullName}</div>
            <div className="abr-cta-title-line">
              {agent.title} &middot; {agent.brokerage} &middot; {agent.licenseLabel}
            </div>
            <div className="abr-cta-title-line is-mls">{agent.mlsLabel}</div>
            <div className="abr-cta-contact">
              <a href={tel}>{agent.phoneDisplay}</a>
              <br />
              <a href={mailto}>{agent.email}</a>
            </div>
          </div>
        </div>
      </div>

      <LegalStrip agent={agent} />
    </section>
  );
};

export default ContactCTA;
